import React, { useState } from 'react';
import useDarkMode from '../hooks/useDarkMode';

const Navbar = () => {
  const [colorTheme, setTheme] = useDarkMode();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <header className="container mx-auto sm:flex sm:justify-between sm:items-center sm:py-3 sm:px-3">
      <div className="flex justify-between items-center py-3 px-3 sm:p-0">
        <div className="transition duration-300 ease-in-out hover:text-white hover:bg-indigo-600 rounded px-2 py-1">
          <a className="sm:text-2xl font-curl" href="/">
            GIG
          </a>
        </div>
        <div>
          <button
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-500 focus:text-white focus:outline-none hover:text-white"
          >
            <svg
              className="h-6 w-6 fill-current sm:hidden"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                className={`${isOpen ? 'block' : 'hidden'}`}
                d="M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
              />
              <path
                className={`${isOpen ? 'hidden' : 'block'}`}
                d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"
              />
            </svg>
          </button>
        </div>
      </div>
      <nav
        className={`px-2 pt-2 pb-4 ${
          isOpen ? 'block' : 'hidden'
        } space-y-1 flex flex-col items-center sm:flex sm:flex-row sm:justify-content sm:space-y-0 sm:space-x-3 text-2xl `}
      >
        <a href="#welcome" className="nav-links">
          Home
        </a>
        <a href="#about" className="nav-links">
          About
        </a>

        <a href="#contact" className="nav-links">
          Contact
        </a>
        <a
          href="https://godis-agu.hashnode.dev/"
          className="nav-links"
          target="_blank"
          rel="noopener noreferrer"
        >
          Blog
        </a>
        <span className={`block self-center px-2`}>
          <svg
            fill="currentColor"
            viewBox="0 0 20 20"
            onClick={() => setTheme(colorTheme)}
            className="w-6 h-6 fill-current cursor-pointer"
          >
            <path
              className={`${colorTheme !== 'light' ? 'block' : 'hidden'}`}
              fillRule="evenodd"
              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
              clipRule="evenodd"
            />
            <path
              className={`${colorTheme === 'light' ? 'block' : 'hidden'}`}
              d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
            />
          </svg>
        </span>
      </nav>
    </header>
  );
};

export default Navbar;
